document.addEventListener("DOMContentLoaded", function() {
  var variantSelector = document.querySelector('form[action^="/cart/add"] [name="id"], select[name="id"]');
  var variantTitle = document.getElementById('variant-title');
  if (!variantSelector || !variantTitle) return;

  var variants = window.productVariants || [];

  function updateTitle() {
    var variantId = variantSelector.value;
    var v = variants.find(function(variant){ return variant.id == variantId; });
    if (v) {
      if (v.title === 'Default Title') {
        variantTitle.textContent = '';
      } else {
        variantTitle.textContent = ' – ' + v.title;
      }
    }
  }

  variantSelector.addEventListener('change', updateTitle);
  // Asegura que esté correcto al cargar la página
  updateTitle();
});
